import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const getCategorySchema = (isEdit) =>
  yup.object({
    categoryName: yup.string().required("Category name is required"),
    subCategories: isEdit
      ? yup
          .array()
          .of(
            yup.object({
              id: yup.string().nullable(),
              value: yup.string().required("Sub-category name is required"),
            }),
          )
          .test(
            "subCategories",
            "At least one sub-category is required",
            (arr) => !arr || arr.length === 0 || arr.every((s) => !!s.value),
          )
      : yup
          .array()
          .of(yup.string().required("Sub-category name is required"))
          .test(
            "subCategories",
            "At least one sub-category is required",
            (arr) => !arr || arr.length === 0 || arr.every((s) => !!s),
          ),
  });

const ProductCategoryModalValidation = ({
  categoryName,
  subCategories = [],
  isEdit,
}) => {
  const normalizedSubCategories = isEdit
    ? subCategories.length
      ? subCategories.map((sub) => ({
          id: sub?.id ?? null,
          value: sub?.value ?? "",
        }))
      : []
    : subCategories.length
      ? subCategories
      : [];

  return useForm({
    resolver: yupResolver(getCategorySchema(isEdit)),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      categoryName,
      subCategories: normalizedSubCategories,
    },
  });
};

export default ProductCategoryModalValidation;
